import { Component, OnInit , AfterViewInit, ViewChild} from '@angular/core';
declare var $: any;
import { DataTableDirective } from 'angular-datatables';

@Component({
  selector: 'app-activity-grid',
  templateUrl: './activity-grid.component.html',
  styleUrls: ['./activity-grid.component.css']
})
export class ActivityGridComponent implements OnInit, AfterViewInit {
  @ViewChild(DataTableDirective)
  datatableElement: DataTableDirective;

  title = "Activities";
  dtOptions: any = {};
 
  constructor() { }

  ngOnInit(): void {
    this.activityList;
    //
    this.dtOptions = {
      dom: 'lBfrtip',
      lengthMenu: [[5, 10, 20, -1], [5, 10, 20, "All"]],
      scroll: "250px",
      select: true,
      buttons: [
        {
          extend: 'collection',
          text: 'Export',
          buttons: ['copy', 'csv', 'excel', 'pdf', 'print',]
        },
        { extend: 'colvis', text: 'Column Visibility', classname: 'btn btn-primary' }
      ],
    }
  }

  activityList = [
    { "subject": 'post', "due-date": '15/05/2020', "contact": '+91 555 555 5555', "account": '013 123 123', "status": 'active' },
    { "subject": 'transfer', "due-date": '18-05-2020', "contact": '+91 555 666 6666', "account": '013 123 456', "status": 'in-active' },
    { "subject": 'received', "due-date": '19-05-2020', "contact": '+91 555 777 7777', "account": '013 123 789', "status": 'active' },
    { "subject": 'post', "due-date": '15-05-2020', "contact": '+91 555 555 5555', "account": '013 123 123', "status": 'active' },
    { "subject": 'post', "due-date": '15-05-2020', "contact": '+91 555 555 5555', "account": '013 123 123', "status": 'active' },
    { "subject": 'post', "due-date": '15-05-2020', "contact": '+91 555 555 3333', "account": '013 123 123', "status": 'active' },
    { "subject": 'post', "due-date": '15-05-2020', "contact": '+91 555 555 2222', "account": '013 123 123', "status": 'active' },
    { "subject": 'transfer', "due-date": '19-05-2020', "contact": '+91 555 666 8888', "account": '013 123 741', "status": 'active' },
  ]

  ngAfterViewInit(): void {
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.columns().every(function () {
        const that = this;
        $('input', this.footer()).on('keyup change', function () {
          if (that.search() !== this['value']) {
            that
              .search(this['value'])
              .draw();
          }
        });
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/Pages/activities/activity-grid/activity-grid.component.ts